<ion-header class="ion-no-border" class="ion-hide-md-up">
  <ion-toolbar class="ion-no-padding-top-important" color="white">
    <ion-back-button
      color="primary"
      defaultHref=""
      slot="start"
      text='{{"RESET_PASSWORD.LOGIN" | translate}}'
    >
    </ion-back-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="passwordForm" height-100>
    <ion-grid height-100 class="ion-no-padding">
      <ion-row
        class="ion-no-padding ion-align-items-center ion-justify-content-center ion-no-padding"
        height-100
      >
        <ion-col sizeLg="6" sizeMd="6" sizeXl="6" sizeSm="0" sizeXs="0" class="ion-no-padding">
          <div class="logo">
            <ion-img class="logo-img ion-hide-sm-down" margin-auto [src]="logo"></ion-img>
          </div>
        </ion-col>

        <ion-col sizeLg="6" sizeMd="6" sizeXl="6" sizeSm="12" sizeXs="12" style="z-index: 2">
          <ion-row class="ion-no-padding ion-align-items-center ion-justify-content-center" max-width-form>
            <ion-col size="12">
              <h4 class="text-primary-dark ion-text-center" medium
                >{{"RESET_PASSWORD.ACTIVATE_ACCOUNT" | translate}}</h4
              >
            </ion-col>

            <ion-col class="ion-margin-bottom" size="12">
              <ion-row>
                <ion-col size="12">
                  <ion-label position="stacked"
                    >{{"RESET_PASSWORD.INFORM_THE_PASSWORD" | translate}}</ion-label
                  >
                  <ion-input
                    class="eye"
                    [type]="showPass ? 'text' : 'password'"
                    placeholder='{{"RESET_PASSWORD.NEW_SENHA" | translate}}'
                    formControlName="password"
                  ></ion-input>
                  <ion-button class="eye" fill="clear" (click)="showPass = !showPass">
                    <ion-icon slot="icon-only" [name]="showPass ? 'eye-off' : 'eye'"></ion-icon>
                  </ion-button>
                </ion-col>
              </ion-row>

              <!-- password required -->
              <ion-note color="danger ion-margin-top" *ngIf="password.dirty && password.errors?.required">
                {{"RESET_PASSWORD.INFORM_YOUR_NEW_PASSWORD" | translate}}
              </ion-note>

              <!-- password min length -->
              <ion-note
                color="danger ion-margin-top"
                *ngIf="password.dirty && !password.errors?.required && password.errors?.minlength"
              >
                {{"RESET_PASSWORD.PASSWORD_MUST_CONTAIN" | translate}} {{
                password.errors.minlength.requiredLength }} {{"RESET_PASSWORD.CHARACTERS_OR_MORE" |
                translate}}
              </ion-note>

              <!-- password max length -->
              <ion-note
                color="danger ion-margin-top"
                *ngIf="password.dirty && !password.errors?.required && !password.errors?.minlength && password.errors?.maxlength"
              >
                {{"RESET_PASSWORD.PASSWORD_MUST_CONTAIN_AT_MOST" | translate}} {{
                password.errors.minlength.requiredLength }} {{"RESET_PASSWORD.CHARACTERS" | translate}}
              </ion-note>
            </ion-col>

            <ion-col class="ion-margin-bottom" size="12">
              <ion-row>
                <ion-col size="12">
                  <ion-label position="stacked">{{"RESET_PASSWORD.CONFIRM_PASSWORD" | translate}}</ion-label>
                  <ion-input
                    class="eye"
                    [type]="showPass ? 'text' : 'password'"
                    formControlName="confirmPassword"
                    placeholder='{{"RESET_PASSWORD.RETYPE_YOUR_NEW_PASSWORD" | translate}}'
                    (keyup.enter)="confirm(passwordForm)"
                  ></ion-input>
                  <ion-button class="eye" fill="clear" (click)="showPass = !showPass">
                    <ion-icon slot="icon-only" [name]="showPass ? 'eye-off' : 'eye'"></ion-icon>
                  </ion-button>
                </ion-col>
              </ion-row>

              <!-- password required -->
              <ion-note
                color="danger ion-margin-top"
                *ngIf="confirmPassword.dirty && confirmPassword.errors?.required"
              >
                {{"RESET_PASSWORD.INFORM_YOUR_NEW_PASSWORD" | translate}}
              </ion-note>

              <!-- password min length -->
              <ion-note
                color="danger ion-margin-top"
                *ngIf="confirmPassword.dirty && !confirmPassword.errors?.required && confirmPassword.errors?.minlength"
              >
                {{"RESET_PASSWORD.PASSWORD_MUST_CONTAIN" | translate}} {{
                confirmPassword.errors.minlength.requiredLength }} {{"RESET_PASSWORD.CHARACTERS_OR_MORE" |
                translate}}
              </ion-note>

              <!-- password max length -->
              <ion-note
                color="danger ion-margin-top"
                *ngIf="confirmPassword.dirty && !confirmPassword.errors?.required && !confirmPassword.errors?.minlength && confirmPassword.errors?.maxlength"
              >
                {{"RESET_PASSWORD.PASSWORD_MUST_CONTAIN_AT_MOST" | translate}} {{
                password.errors.minlength.requiredLength }} {{"RESET_PASSWORD.CHARACTERS" | translate}}
              </ion-note>

              <ion-note
                color="danger ion-margin-top"
                *ngIf="confirmPassword.dirty && !confirmPassword.errors?.required && !confirmPassword.errors?.minlength && !confirmPassword.errors?.maxlength && confirmPassword.errors?.invalidConfirmPassword"
              >
                {{"RESET_PASSWORD.PASSWORDS_DO_NOT_MATCH" | translate}}
              </ion-note>
            </ion-col>

            <ion-col size="12" class="ion-margin-top">
              <ion-button max-width-form expand="block" color="buttonPrimary" (click)="confirm(passwordForm)"
                >{{"RESET_PASSWORD.ACTIVATE_ACCOUNT" | translate}}</ion-button
              >
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
  <div class="square"></div>
</ion-content>
